export default {fields:{boxSchemas:{spreads:{BoxSchema:{}}}},typenameResolver:'QueryTypenameResolver'}